export default {
  ADDRESS: 'Address',
  BIRTHPLACE: 'Birthplace',
  IDENTIFICATION_BIRTH_PLACE: 'Identification Birthplace',
  PVQ_COURT_MARTIAL_LOCATION: 'PVQ Court Martial Location',
  PVQ_COURT_MARTIAL_OFFENSE_LOCATION: 'PVQ Court Martial Offense Location',
  PVQ_DOMESTIC_FOREIGN_MILITARY_DIPLOMATIC_LOCATION: 'PVQ_Domestic_Foreign_Military_Diplomatic_Location',
  BIRTHPLACE_WITHOUT_COUNTY: 'Birthplace without County',
  INTERNATIONAL_CITY_COUNTRY_ONLY: 'International city country only',
  COUNTRY: 'Country',
  US_CITY_STATE_INTERNATIONAL_CITY: 'US City, State, International city',
  US_CITY_STATE_INTERNATIONAL_CITY_COUNTRY: 'US City, State, International city country',
  US_CITY_STATE_COUNTY_INTERNATIONAL_CITY_COUNTRY: 'US City, State, County, International city country',
  US_COUNTY_CITY_STATE_ZIP_INTERNATIONAL_CITY_COUNTRY: 'US County, City, State, Zip, International city country',
  US_STREET_CITY_COUNTY_STATE_ZIP: 'US Street, City, County, State, Zipcode',
  US_STREET_CITY_STATE_ZIP: 'US Street, City, State, Zipcode',
  STATE: 'State',
  CITY_STATE: 'City, State',
  STREET_CITY_COUNTRY: 'Street, City, Country',
  CITY_COUNTRY: 'City, Country',
  US_CITY_STATE_ZIP_INTERNATIONAL_CITY: 'US City, State, Zipcode International city',
  CITY_STATE_COUNTRY: 'City, State, Country',
  US_ADDRESS: 'US Address',
  STREET_CITY: 'Street, City',
  OFFENSE: 'Offense',
};
